/*========================================================================
* $Id: browser.js 95818 2017-02-03 11:56:02Z daniel.eppensteiner $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define(["underscore"], function(_) {

    var persistedsourceinfo = {

      userAvailable: function(path, application, options) {
        var userAvailable = false;
        _.find(application.models.userSourceInfo.get("sources") && application.models.userSourceInfo.get("sources").sources, _.bind(function(source) {
          _.find(source.services, _.bind(function(service) {
            if (service.id == "persistedcollectionschema") {
              _.find(service.options, _.bind(function (options) {
                if (options.path == path) {
                  if (options.authenticated_available) userAvailable = true;
                }
              }, this))
            }
          }, this));
        }, this));

        return userAvailable;
      },

      persistedcollectionschemaAvailable: function (path, application, alwaysAvailable) {
        var isAvailable = false;
        _.find(application.models.sourceInfo.get("sources") && application.models.sourceInfo.get("sources").sources, _.bind(function(source) {
          _.find(source.services, _.bind(function(service) {
            if (service.id == "persistedcollectionschema") {
              _.find(service.options, _.bind(function (options) {
                if (options.path == path) {
                  if (alwaysAvailable) {
                    isAvailable = true;
                  } else {
                    isAvailable = this.userAvailable(path, application, options);
                  }
                }
              }, this))
            }
          }, this));
        }, this));

        return isAvailable;
      }

    };

    return persistedsourceinfo;
});
